import { Box } from "@chakra-ui/react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useLayoutEffect, useState } from "react";
import { SmsInputStats } from "../components/SmsInputStats";
import { editorStateToPlainText } from "../utils/converters";

/**
 * @deprecated SegmentedMessagePlugin will be used instead of this plugin
 */
export default function SmsStatsPlugin(): JSX.Element {
  const [editor] = useLexicalComposerContext();
  const [rawText, setRawText] = useState("");

  useLayoutEffect(() => {
    return editor.registerUpdateListener(
      ({ editorState, dirtyElements, dirtyLeaves, prevEditorState, tags }) => {
        if (
          (dirtyElements.size === 0 && dirtyLeaves.size === 0) ||
          tags.has("history-merge") ||
          prevEditorState.isEmpty()
        ) {
          return;
        }

        setRawText(editorStateToPlainText(editorState));
      }
    );
  }, [editor]);

  return (
    <Box pt={2} px={4} borderTop="1px solid" borderColor="gray.200">
      <SmsInputStats value={rawText} />
    </Box>
  );
}
